const  router = [
	{
		path: "/mendian/layout",
		component: () => import('../../../pages/mendian/Layout.vue'),
		meta: {title: '门店'},
		name: 'mendianIndex',
		children:[
			{
				path: "/mendian",
				component: () => import('../../../pages/mendian/Mendian.vue'),
				meta: {title: '门店管理', type:'c', permission: 'mendian_index'},
				name: 'mendianIndex',
			},
			{
				path: "/room",
				component: () => import('../../../pages/mendian/Room.vue'),
				meta: {title: '房间管理', type:'c', permission: 'room_index'},
				name: 'room_index',
			},
			{
				path: "/mendian/project",
				component: () => import('../../../pages/mendian/Project.vue'),
				meta: {title: '项目管理', type:'c', permission: 'mendian_project'},
				name: 'mendian_project'
			},
			{
				path: "/mendian/project/edit",
				component: () => import('../../../pages/mendian/EditProject.vue'),
				meta: {title: '编辑项目', type:'c', permission: 'mendian_project_edit'},
				name: 'mendian_project_edit'
			},
			
		],
	}
];

export default router